import React, { useState } from "react";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Text from "@amzn/meridian/text";

import { DatesModal } from "./DatesModal";
import { ImpDatesTable } from "./ImpDatesTable";

interface IImportantDatesProps {
    data: any;
    isEditing: boolean;
    handleInputChange: (field: string, value: any) => void;
}

export const ImportantDates: React.FC<IImportantDatesProps> = ({
    data,
    isEditing,
    handleInputChange,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <Box type="fill" width="60%" spacingInset="400">
            <Row
                wrap="down"
                width="auto"
                alignmentHorizontal="justify"
                widths={["fill", "fit"]}
                spacing="350"
                spacingInset="0 0 200 0"
            >
                <Box>
                    <Box height="6px" />
                    <Text type="h200">Important Dates</Text>
                </Box>
                <Box>
                    <Box height="6px" />
                    <Button onClick={() => setIsModalOpen(true)} disabled={!isEditing}>
                        Add/Edit Dates
                    </Button>
                </Box>
            </Row>

            <ImpDatesTable data={data} />
            <DatesModal
                data={data}
                handleInputChange={handleInputChange}
                open={isModalOpen}
                setOpen={setIsModalOpen}
            />
        </Box>
    );
};
